import { createFileRoute } from '@tanstack/react-router';
import { PoliciesPage } from '@/domains/credit';

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/credit/policies')({
    component: PoliciesPage,
});
